import React, {useEffect, useRef, useState} from 'react';

import Box from "@mui/material/Box";
import {InputLabel, Select, Stack, TextField} from "@mui/material";
import Button from "@mui/material/Button";
import {useForm} from "react-hook-form";


import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {useDispatch, useSelector} from "react-redux";
import {
    getStatuses, getPayStatuses,
    getPaymentSystems
} from "./ProfileClient";
import {changeProfile} from "./profileSlice";
import {changeProfileSearch} from "./profileSearchSlice";
import FormDatePicker from "../../CommonComponents/FormDatePicker";
import CircularProgressOverlay from "../../CommonComponents/CircularProgressOverlay";




export default function ProfileSearch({gridClear}) {

    const selectorSubmitting = useSelector((state) => state.externalDataSlc.value.submitting);

    const { register, handleSubmit, control, setValue, reset } = useForm();
    // const {register, handleSubmit} = useForm();
    const [paymentSystemDropdown, setPaymentSystemDropdown] = useState([]);
    const [selectedPaymentSystem, setSelectedPaymentSystem] = useState(null);
    const [payStatusDropdown, setPayStatusDropdown] = useState([]);
    const [selectedPayStatus, setSelectedPayStatus] = useState(null);
    const [statusDropdown, setStatusDropdown] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [productionTypeDropdown, setProductionTypeDropdown] = useState([]);
    const [selectedProductionType, setSelectedProductionType] = useState(null);
    const [minorDropdown, setMinorDropdown] = useState([]);
    const [selectedMinor, setSelectedMinor] = useState(null);
    const [livingOrDeadDropdown, setLivingOrDeadDropdown] = useState([]);
    const [selectedLivingOrDead, setSelectedLivingOrDead] = useState(null);
    const setupsDropdown = ["","Has","None"];
    const yesNoDropdown = ["","Yes","No"];
    const [selectedParticipations, setSelectedParticipations] = useState(null);
    const [selectedResiduals, setSelectedResiduals] = useState(null);
    const [selectedRoyalties, setSelectedRoyalties] = useState(null);
    const [r2mDropdown, setR2mDropdown] = useState([]);
    const [profileValue, setProfileValue] = useState([]);
    const [guildValue, setGuildValue] = useState([]);
    const [r2mValue, setR2mValue] = useState([]);
    const dispatchData = useDispatch();
    const [profiles, setProfiles] = useState([]);

    const handleClearClick = () => {
        setProfileValue("");

    };

    const handleClearProfileClick = () => {
        setProfileValue("");
    };

    const fetchPaymentSystems = () =>
        getPaymentSystems()

            .then(data => {
                console.log("Payment Systems");
                console.log(data);
                console.log("Payment Systems with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setPaymentSystemDropdown(data);
            })


    const fetchPayStatuses = () => {
        getPayStatuses()

            .then(data => {
                console.log("Pay Status");
                console.log(data);
                console.log("Pay Status with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setPayStatusDropdown(data);
            })}


    const fetchStatuses = () =>
        getStatuses()

            .then(data => {
                console.log("Statuses");
                console.log(data);
                console.log("Statuses with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setStatusDropdown(data);
            })

    useEffect(() => {
        console.log("This is for the M4mkt Group dropdown...");
        fetchPaymentSystems();
        fetchPayStatuses();
        fetchStatuses();
    }, []);


    function onSubmit(data) {
        console.log("here's my profile search data before I submit it ")
        console.log({data});
        dispatchData(changeProfileSearch({
            id: data.id,
            externalId: data.externalId,
            firstName: data.firstName,
            lastName: data.lastName,
            ssn: data.ssn,
            dateOfBirthFrom: data.dateOfBirthFrom,
            dateOfBirthTo: data.dateOfBirthTo,
            minor: data.minor,
            dateOfDeathFrom: data.dateOfDeathFrom,
            dateOfDeathTo: data.dateOfDeathTo,
            livingOrDead: data.livingOrDead,
            companyName: data.companyName,
            fein: data.fein,
            dateOfDissolutionFrom: data.dateOfDissolutionFrom,
            dateOfDissolutionTo: data.dateOfDissolutionTo,
            paymentSystem: data.paymentSystem,
            payStatus: data.payStatus,
            status: data.status,
            participations: data.participations,
            residuals: data.residuals,
            royalties: data.royalties
        }));
        dispatchData(changeProfile({
            profileGridRefresh: true
        }));
    };

    const handleClear = () => {

        reset({
            id: '',
            externalId: '',
            firstName: '',
            lastName: '',
            ssn: '',
            dateOfBirthFrom: '',
            dateOfBirthTo: '',
            minor: '',
            dateOfDeathFrom: '',
            dateOfDeathTo: '',
            livingOrDead: '',
            companyName: '',
            fein: '',
            dateOfDissolutionFrom: '',
            dateOfDissolutionTo: '',
            paymentSystem: '',
            payStatus: '',
            status: '',
            participations: '',
            residuals: '',
            royalties: ''
        });

        ('');
        setSelectedMinor('');
        setSelectedLivingOrDead('');
        setSelectedPaymentSystem('');
        setSelectedPayStatus('');
        setSelectedStatus('');
        setSelectedParticipations('');
        setSelectedResiduals('');
        setSelectedRoyalties('');

        gridClear()
    };

    const handlePaymentSystemChange = (paymentSystemEvent) => {
        setSelectedPaymentSystem(paymentSystemEvent.target.value);
        console.log("This is for the selected Value");
        console.log(paymentSystemEvent.target.value);
    };

    const handlePayStatusChange = (payStatusEvent) => {
        setSelectedPayStatus(payStatusEvent.target.value);
        console.log("This is for the selected Value");
        console.log(payStatusEvent.target.value);
    };

    const handleStatusChange = (statusEvent) => {
        setSelectedStatus(statusEvent.target.value);
        console.log("This is for the selected Value");
        console.log(statusEvent.target.value);
    };


    const handleMinorChange = (minorEvent) => {
        setSelectedMinor(minorEvent.target.value);
        console.log("This is for the selected Value");
        console.log(minorEvent.target.value);
    };

    const handleLivingOrDeadChange = (livingOrDeadEvent) => {
        setSelectedLivingOrDead(livingOrDeadEvent.target.value);
        console.log("This is for the selected Value");
        console.log(livingOrDeadEvent.target.value);
    };

    const handleParticipationsChange = (participationsEvent) => {
        setSelectedParticipations(participationsEvent.target.value);
        console.log("This is for the selected Value");
        console.log(participationsEvent.target.value);
    };

    const handleResidualsChange = (residualsEvent) => {
        setSelectedResiduals(residualsEvent.target.value);
        console.log("This is for the selected Value");
        console.log(residualsEvent.target.value);
    };

    const handleRoyaltiesChange = (royaltiesEvent) => {
        setSelectedRoyalties(royaltiesEvent.target.value);
        console.log("This is for the selected Value");
        console.log(royaltiesEvent.target.value);
    };
    const handleClearPaymentSystem = () => {
        setSelectedPaymentSystem("");}


    const selectR2mRef = useRef();

    const onClear = () => {
    };

    const searchForm  = () => (
        <form
            onSubmit={handleSubmit((data)=>        onSubmit(data))}
        >
            <Box
                sx={{  height: 360, pl: 5}}
                role="presentation"
            >
                <Stack direction={"Horizontal"} sx={{ pb: 1 }}>
                    <TextField variant="filled"
                               {...register('id', { required: false })}
                               id="id"   name="id"  label="ID" aria-describedby="id_entry"
                               sx={{ width: 170, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('externalId', { required: false })}
                               id="externalId"   name="externalId"  label="External ID" aria-describedby="externalId_entry"
                               sx={{ width: 170, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('firstName', { required: false })}
                               id="firstName"   name="firstName"  label="First Name" aria-describedby="firstName_entry"
                               sx={{ width: 300, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('lastName', { required: false })}
                               id="lastName"   name="lastName"  label="Last Name" aria-describedby="lastName_entry"
                               sx={{ width: 300, pr: 5  }} />
                    <TextField variant="filled"
                               {...register('ssn', { required: false })}
                               id="ssn"   name="ssn"  label="SSN" aria-describedby="ssn_entry"
                               sx={{ width: 150, pr: 5 }} />
                </Stack>
                <Stack direction={"horizontal"}  sx={{ pb: 1 }}>
                    <FormDatePicker
                        name="dateOfBirthFrom"
                        label="Date of Birth From"
                        control={control}
                        width={220}
                    />
                    <FormDatePicker
                        name="dateOfBirthTo"
                        label="Date of Birth To"
                        control={control}
                        width={220}
                    />
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('dateOfBirthFrom', { required: false })}*/}
                    {/*           id="dateOfBirthFrom"   name="dateOfBirthFrom"  label="Date of Birth From" aria-describedby="dateOfBirthFrom_entry"*/}
                    {/*           sx={{ width:220, pr: 5 }} />*/}
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('dateOfBirthTo', { required: false })}*/}
                    {/*           id="dateOfBirthTo"   name="dateOfBirthTo"  label="Date of Birth To" aria-describedby="dateOfBirthTo_entry"*/}
                    {/*           sx={{ width:220, pr: 5 }} />*/}
                        <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                            <InputLabel sx={{ ml: 1}} htmlFor="minor">Minor</InputLabel>
                            <Select
                                {...register('minor', { required: false })}
                                labelId="demo-simple-select-filled-minor"
                                id="minor"
                                FreeSolo={true}
                                variant="filled"
                                label="minor"
                                value={selectedMinor}
                                onChange={handleMinorChange}
                                sx={{ width: 200}}
                            >
                                {yesNoDropdown.map((yesNoItem) =>
                                    <MenuItem  FreeSolo={true} value={yesNoItem} key={yesNoItem}
                                    >{yesNoItem}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    <FormDatePicker
                        name="dateOfDeathFrom"
                        label="Date of Death From"
                        control={control}
                        width={230}
                    />
                    <FormDatePicker
                        name="dateOfDeathTo"
                        label="Date of Death To"
                        control={control}
                        width={230}
                    />
                        {/*<TextField variant="filled"*/}
                        {/*           {...register('dateOfDeathFrom', { required: false })}*/}
                        {/*           id="dateOfDeathFrom"   name="dateOfDeathFrom"  label="Date of Death From" aria-describedby="dateOfDeathFrom_entry"*/}
                        {/*           sx={{ width:220, pr: 5 }} />*/}
                        {/*<TextField variant="filled"*/}
                        {/*           {...register('dateOfDeathTo', { required: false })}*/}
                        {/*           id="dateOfDeathTo"   name="dateOfDeathTo"  label="Date of Death To" aria-describedby="dateOfDeathTo_entry"*/}
                        {/*           sx={{ width:220, pr: 5 }} />*/}
                        <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                            <InputLabel sx={{ ml: 1}} htmlFor="livingOrDead">Alive</InputLabel>
                            <Select
                                {...register('livingOrDead', { required: false })}
                                labelId="demo-simple-select-filled-livingOrDead"
                                id="livingOrDead"
                                FreeSolo={true}
                                variant="filled"
                                label="livingOrDead"
                                value={selectedLivingOrDead}
                                onChange={handleLivingOrDeadChange}
                                sx={{ width: 200}}
                            >
                                {yesNoDropdown.map((yesNoItem) =>
                                    <MenuItem  FreeSolo={true} value={yesNoItem} key={yesNoItem}
                                    >{yesNoItem}</MenuItem>

                                )}
                            </Select>
                        </FormControl>
                    </Stack>
                    <Stack direction={"Horizontal"}  sx={{ pb: 1 }}>
                    <TextField variant="filled"
                               {...register('companyName', { required: false })}
                               id="companyName"   name="companyName"  label="Company Name" aria-describedby="companyName_entry"
                               sx={{ width: 400, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('fein', { required: false })}
                               id="fein"   name="fein"  label="FEIN" aria-describedby="fein_entry"
                               sx={{ width: 120, pr: 5 }} />
                        <FormDatePicker
                            name="dateOfDissolutionFrom"
                            label="Date of Dissolution From"
                            control={control}
                            width={260}
                        />
                        <FormDatePicker
                            name="dateOfDissolutionTo"
                            label="Date of Dissolution To"
                            control={control}
                            width={260}
                        />
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('dateOfDissolutionFrom', { required: false })}*/}
                    {/*           id="dateOfDissolutionFrom"   name="dateOfDissolutionFrom"  label="Date of Dissolution From" aria-describedby="dateOfDissolutionFrom_entry"*/}
                    {/*           sx={{ width: 250, pr: 5 }} />*/}
                    {/*    <TextField variant="filled"*/}
                    {/*               {...register('dateOfDissolutionTo', { required: false })}*/}
                    {/*               id="dateOfDissolutionTo"   name="dateOfDissolutionTo"  label="Date of Dissolution To" aria-describedby="dateOfDissolutionTo_entry"*/}
                    {/*               sx={{ width: 250, pr: 5 }} />*/}
                    </Stack>

                    <Stack direction={"Horizontal"}  sx={{ pb: 1 }}>


                    <FormControl variant="standard" sx={{ ml: 1, pr: 5, minWidth: 300 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="paymentSystem">Payment System</InputLabel>
                        <Select
                            {...register('paymentSystem', { required: false })}
                            labelId="demo-simple-select-filled-paymentSystem"
                            id="paymentSystem"
                            FreeSolo={true}
                            variant="filled"
                            value={selectedPaymentSystem}
                            label="paymentSystem"
                            onChange={handlePaymentSystemChange}
                            sx={{ width: 300}}
                        >
                            {paymentSystemDropdown.map((paymentSystemItem) =>
                                <MenuItem  FreeSolo={true} value={paymentSystemItem.singleField} key={paymentSystemItem.singleField}
                                >{paymentSystemItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 300 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="payStatus">Pay Status</InputLabel>
                        <Select
                            {...register('payStatus', { required: false })}
                            labelId="demo-simple-select-filled-payStatus"
                            id="payStatus"
                            FreeSolo={true}
                            variant="filled"
                            label="payStatus"
                            value={selectedPayStatus}
                            onChange={handlePayStatusChange}
                            sx={{ width: 300}}
                        >
                            {payStatusDropdown.map((payStatusItem) =>
                                <MenuItem  FreeSolo={true} value={payStatusItem.singleField} key={payStatusItem.singleField}
                                >{payStatusItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="status">Status</InputLabel>
                        <Select
                            {...register('status', { required: false })}
                            labelId="demo-simple-select-filled-status"
                            id="status"
                            FreeSolo={true}
                            variant="filled"
                            label="status"
                            value={selectedStatus}
                            onChange={handleStatusChange}
                            sx={{ width: 200}}
                        >
                            {statusDropdown.map((statusItem) =>
                                <MenuItem  FreeSolo={true} value={statusItem.singleField} key={statusItem.singleField}
                                >{statusItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    </Stack>

                <Stack direction={"Horizontal"}  sx={{ pb: 1 }}>
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="participations">Participations</InputLabel>
                        <Select
                            {...register('participations', { required: false })}
                            labelId="demo-simple-select-filled-participations"
                            id="participations"
                            FreeSolo={true}
                            variant="filled"
                            label="participations"
                            value={selectedParticipations}
                            onChange={handleParticipationsChange}
                            sx={{ width: 200}}
                        >
                            {setupsDropdown.map((setupsItem) =>
                                <MenuItem  FreeSolo={true} value={setupsItem} key={setupsItem}
                                >{setupsItem}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="residuals">Residuals</InputLabel>
                        <Select
                            {...register('residuals', { required: false })}
                            labelId="demo-simple-select-filled-residuals"
                            id="residuals"
                            FreeSolo={true}
                            variant="filled"
                            label="residuals"
                            value={selectedResiduals}
                            onChange={handleResidualsChange}
                            sx={{ width: 200}}
                        >
                            {setupsDropdown.map((setupsItem) =>
                                <MenuItem  FreeSolo={true} value={setupsItem}>{setupsItem}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="royalties">Royalties</InputLabel>
                        <Select
                            {...register('royalties', { required: false })}
                            labelId="demo-simple-select-filled-royalties"
                            id="royalties"
                            FreeSolo={true}
                            variant="filled"
                            label="royalties"
                            value={selectedRoyalties}
                            onChange={handleRoyaltiesChange}
                            sx={{ width: 200}}
                        >
                            {setupsDropdown.map((setupsItem) =>
                                <MenuItem  FreeSolo={true} value={setupsItem}>{setupsItem}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <Button
                        type= "submit"
                    >RETRIEVE</Button>
                    <Button onClick={handleClear}
                    >CLEAR</Button>
                </Stack>
            </Box>
        </form>
    );

    return (
        <Box sx={{ position: 'relative' }}>
            {searchForm()}
            {selectorSubmitting && <CircularProgressOverlay/>}
        </Box>

    )


}

